module.exports = function (SddDialogService, $window) {
    return {
        restrict: 'E',
        scope: {},
        controllerAs: 'vm',
        link(scope) {
            scope.sddDialogService = SddDialogService;
            scope.vm = {
                isMobileScreen: window.innerWidth < 768
            };

            scope.closePanel = function () {
                SddDialogService.close();
            };
        },
        template: require('./sdd-dialog-template.html').trim()
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/sdd-dialog/sdd-dialog-directive.js
 **/